import { GlButton, GlLink, GlTooltip, GlTooltipDirective } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { createAlert } from '../../../../alert.js?vue3';
import { reportToSentry } from '~/ci/utils';
import { __, s__ } from '~/locale';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import CiIcon from '../../../../vue_shared/components/ci_icon/ci_icon.vue?vue3';
import { BRIDGE_KIND, BUILD_KIND } from '~/ci/pipeline_details/graph/constants';
import RetryMrFailedJobMutation from '~/ci/merge_requests/graphql/mutations/retry_mr_failed_job.mutation.graphql';
import RootCauseAnalysisButton from '../../../../../../../ee/app/assets/javascripts/ci/job_details/components/root_cause_analysis_button.vue?vue3';
export default {
    name: 'FailedJobDetails',
    components: {
        CiIcon,
        GlButton,
        GlLink,
        GlTooltip,
        RootCauseAnalysisButton
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        job: {
            type: Object,
            required: true
        },
        canTroubleshootJob: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'job-retried'
    ],
    data () {
        return {
            isLoadingAction: false
        };
    },
    computed: {
        canRetryJob () {
            return this.job.retryable && this.job.userPermissions.updateBuild && !this.isBridgeJob;
        },
        detailedStatus () {
            return this.job?.detailedStatus;
        },
        detailsPath () {
            return this.detailedStatus?.detailsPath;
        },
        statusGroup () {
            return this.detailedStatus?.group;
        },
        isBridgeJob () {
            return this.job.kind === BRIDGE_KIND;
        },
        parsedJobId () {
            return getIdFromGraphQLId(this.job.id);
        },
        tooltipErrorText () {
            return this.isBridgeJob ? this.$options.i18n.cannotRetryTrigger : this.$options.i18n.cannotRetry;
        },
        isBuildJob () {
            return this.job.kind === BUILD_KIND;
        }
    },
    methods: {
        async retryJob () {
            try {
                this.isLoadingAction = true;
                const { data: { jobRetry: { errors } } } = await this.$apollo.mutate({
                    mutation: RetryMrFailedJobMutation,
                    variables: {
                        id: this.job.id
                    }
                });
                if (errors.length > 0) {
                    throw new Error(errors[0]);
                }
                this.$emit('job-retried', this.job.name);
            } catch (error) {
                createAlert({
                    message: error?.message || this.$options.i18n.retryError
                });
                reportToSentry(this.$options.name, error);
            } finally{
                this.isLoadingAction = false;
            }
        }
    },
    i18n: {
        cannotReadBuild: s__("Job|You do not have permission to read this job's log."),
        cannotRetry: s__('Job|You do not have permission to run this job again.'),
        cannotRetryTrigger: s__('Job|You cannot rerun trigger jobs from this list.'),
        retry: __('Run again'),
        retryError: __('There was an error while running this job again')
    }
};
